export default "__VITE_ASSET__BiMyNy7t__"